const Manage = () => import('@/views/main/material/manage/Manage.vue')
export default {
  path: '/main/material/manage',
  name: 'Manage',
  component: Manage,
  children: []
}
